import { atom } from 'recoil';
import type { ExternaleCaseDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/policyjob/edi/dto/';
import { externalCasesSelector } from '../selectors/externalCasesSelector';

export const externalCasesAtom = atom<ExternaleCaseDTO[]>({
    key: 'externalCasesAtom',
    default: externalCasesSelector
});
